<template>
  <div class="main">
    <div class="banner">
      <img src="@/assets/img/long-banner.png" alt="">
    </div>
    <div class="service-content">
      <h2 class="title">奇绩创坛校友企业注册落地服务</h2>
      <div class="service-info">
        <div class="info-text">
          <h3>为奇绩创坛校友提供两年免费虚拟注册地址并提供注册服务</h3>
          <p class="text-list"><span></span>注册地址及注册服务适用于奇绩创坛校友企业在海淀设立、迁址主体、子公司、持股平台使用</p>
          <p class="text-list"><span></span>注册地址为集群注册地址</p>
        </div>
        <div class="info-img">
          <img src="@/assets/img/service.png" alt="">
        </div>
      </div>
    </div>
    <div class="service-process">
      <div class="process-box">
        <h2 class="title">服务流程</h2>
        <div class="legend">
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 8.png" alt="">
              <p>点击“我要咨询” 填写表格</p>
            </div>
            <div class="arrow"><img src="@/assets/img/右箭头.png" alt="箭头"></div>
          </div>
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 9.png" alt="">
              <p>奇绩专属管家对接</p>
            </div>
            <div class="arrow"><img src="@/assets/img/右箭头.png" alt="箭头"></div>
          </div>
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 10.png" alt="">
              <p>企业核名</p>
            </div>
            <div class="arrow"><img src="@/assets/img/右箭头.png" alt="箭头"></div>
          </div>
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 11.png" alt="">
              <p>地址材料准备</p>
            </div>
            <div class="arrow"><img src="@/assets/img/右箭头.png" alt="箭头"></div>
          </div>
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 13.png" alt="">
              <p>公司材料提交<br/><span style="color:#666;font-size:12px;font-weight: 400;line-height: 17px;margin:0;">（外资、持股平台仅支 持线下提交内资可全 程线上办理）</span></p>
            </div>
            <div class="arrow"><img src="@/assets/img/右箭头.png" alt="箭头"></div>
          </div>
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 14.png" alt="">
              <p>法人、股东配合完成身份确认、业务确认（如需要）</p>
            </div>
            <div class="arrow"><img src="@/assets/img/右箭头.png" alt="箭头"></div>
          </div>
          <div class="legend-item">
            <div>
              <img src="@/assets/img/编组 15.png" alt="">
              <p>企业注册结果反馈</p>
            </div>
            <div></div>
          </div>
        </div>
        <p class="text-list"><span></span>企业提供：注册所需材料，包括但不限于法人、股东个人信息、身份信息等</p>
        <p class="text-list"><span></span>公司注册完成后，需尽快进行税务报道、银行开户、社保开户等后续工作。</p>
        <p class="text-list"><span></span>税务要求,企业注册完成后30天内需办理税务报到,会计按月申报纳税,否则有可能会被工商报异常。</p>
      </div>
    </div>
    <div class="consulting">
      <button @click="toForm()">我要咨询</button>
    </div>
  </div>
</template>

<script>
export default {
  name:"enterpriseRegister",
  data() {
    return {
      
    }
  },
  methods: {
    toForm() {
      this.$router.push('/enterpriseRegister/form')
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  min-height: 500px;
  .banner {
    width: 100%;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .title {
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    font-weight: 400;
    color: #0079FF;
    border-left: 20px solid #0079FF;
    padding-left: 13px;
  }
  .service-content {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    .service-info {
      display: flex;
      .info-text {
        margin-top: 100px;
        margin-left: 100px;
        h3 {
          font-size: 20px;
          font-weight: 500;
          color: #666666;
          margin-left: 15px;
          margin-bottom: 25px;
        }
        p {
          font-size: 14px;
          font-weight: 700;
          color: #222222;
        }
      }
    }
    .info-img {
      margin: 70px 0 30px 50px;
      img {
        width: 226px;
        height: 198px;
      }
    }
  }
  .service-process {
    height: 387px;
    background: #F6F6F6;
    padding: 40px 0;
    .process-box {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .legend {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .legend-item {
          display: flex;
          text-align: center;
          justify-content: space-between;
          width: 150px;
          height: 230px;
          p {
            margin-top: 30px;
            width: 120px;
            height: 40px;
            font-size: 14px;
            font-weight: 600;
            color: #222222;
            line-height: 20px;
          }
          .arrow {
            img {
              margin-top: 135px;
            }
          }
        }
      }
      .text-list {
        font-size: 14px;
        font-weight: 600;
        color: #666666;
      }
    }
  }
  .consulting {
    padding: 60px 0;
    text-align: center;
    button {
      width: 116px;
      height: 44px;
      background: #0079FF;
      border-radius: 4px;
      border: none;
      color: #fff;
      cursor: pointer;
    }
    button:hover {
      background-color: #0069DC;
    }
  }

  .text-list {
    margin-top: 10px;
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      margin-right: 15px;
      background: #0079FF;
      margin-left: 15px;
      -moz-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg); 
    }
  }
}
</style>>

 